import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "logo_wl_narrow_color",
  "use": "logo_wl_narrow_color-usage",
  "viewBox": "0 0 151 109",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 151 109\" id=\"logo_wl_narrow_color\"><rect width=\"100%\" height=\"100%\" fill=\"none\" /><g class=\"currentLayer\"><path fill=\"#e2b040\" d=\"M102.29 0h-27L53.05 52.95l18-4.77-15.88 31.77c-3.12-6.15-27.6-56.59-27.6-56.59H0l47.36 85.88 51.22-81.18-16.81 5.03L102.29 0z\" /><path fill=\"#663bec\" d=\"M125.06 23.36l-22.5 42.25L91.8 48.85 80.31 67.06l22.84 42.25 47.5-85.95z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol